export default {
  NIT: 1,
  CI: 2,
  CEX: 3,
  PASS: 4,
  OTROS: 5,
};
